// src/Services/FosWalletChange.js
import axios from "axios";

// Thin client — the actual FOS-wallet mutations live server-side in
// SALES-APP-BACKEND-NODE-API's routes/fosWalletChangeRoutes.js, which itself
// proxies to Referral-Loyalty-Backend. This file exists purely so
// LeadSourceChange.jsx's gate check didn't need direct backend URLs/secrets.
const BASE_URL = `${process.env.REACT_APP_PAYMENT_LINK_URL}fos-wallet-change`;

async function postToBackend(path, body, fallbackMessage) {
  try {
    const response = await axios.post(`${BASE_URL}${path}`, body);
    if (!response.data?.success) {
      const err = new Error(response.data?.message || fallbackMessage);
      err.blocked = response.data?.blocked || false;
      throw err;
    }
    return response.data;
  } catch (err) {
    if (err.blocked !== undefined) throw err;
    const wrapped = new Error(err.response?.data?.message || err.message || fallbackMessage);
    wrapped.blocked = err.response?.data?.blocked || false;
    throw wrapped;
  }
}

export const switchFosToFos = (allotmentId, newFosSalesAppId) =>
  postToBackend("/switch-fos-to-fos", { allotmentId, newFosSalesAppId }, "Failed to switch FOS.");

export const assignFosFirstTime = (salesAppLeadId, newFosSalesAppId, leadDetails, allotmentStatus) =>
  postToBackend(
    "/assign-fos-first-time",
    { salesAppLeadId, newFosSalesAppId, leadDetails, allotmentStatus },
    "Failed to assign FOS for the first time."
  );

export const removeFosOnSwitchToDirect = (allotmentId) =>
  postToBackend("/remove-fos-switch-to-direct", { allotmentId }, "Failed to remove FOS on switch to Direct.");

// Read-only check — no mutation. Call this BEFORE the CP-payment gate and
// Farvision calls, so a debited allotment is rejected before anything else
// runs. Returns { exists, hasActiveDebit }.
export const checkFosSwitchEligibility = (allotmentId) =>
  postToBackend("/check-fos-switch-eligibility", { allotmentId }, "Failed to check FOS switch eligibility.");
